import React, { useState } from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getUnits, getCumulativeResult } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import SjpTrialResults from "components/sports/sjp/views/SjpTrialResults";
import SjpFinalResults from "components/sports/sjp/views/SjpFinalResults";
import PreviousCompetitor from "components/sports/sjp/views/PreviousCompetitor";
import CurrentCompetitor from "components/sports/sjp/views/CurrentCompetitor";
import PreviousCompetitorMix from "components/sports/sjp/views/PreviousCompetitorMix";
import CurrentCompetitorMix from "components/sports/sjp/views/CurrentCompetitorMix";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Label from "components/general/Label";
import { isLiveStatus } from "helpers/status";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getPhaseRSC, getLongPhaseRSC, getLevelRSC, getLongEventRSC } from 'helpers/rsc'
import {
    RESULT_STATUS,
    getResultStatusAsInteger,
  } from "helpers/status";
import { getIsMixed } from 'components/sports/sjp/helper/SjpHelpers'

const SjpContext = () => {
    const { mirs_rsc, mirs_competition, mirs_language,mirs_discipline } = useUrlFriendlyToParameters()
    const _longEvent = getLongEventRSC(mirs_rsc);
    const _longPhase = getLongPhaseRSC(mirs_rsc);

    const _phase = getPhaseRSC(mirs_rsc);
    let filterScheduled = getLevelRSC(mirs_rsc) === 'PHASE' ? 'S' : 'Y'

        //GET units in phase
        const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
            {
                queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase, filterScheduled],
                queryFn: getUnits,
                //refetchInterval: 30000,
                staleTime: Infinity,
                refetchIntervalInBackground: true,
                notifyOnChangeProps: ['data', 'error'],
            }
        );

        let queryArray1Round = [];

        //GET 1st Round Results
        unitsData?.phase?.units?.forEach((unit) => {
            queryArray1Round.push({
                queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase],
                queryFn: getResultsRSC,
                refetchInterval: 5000,
                staleTime: 5000,
                refetchIntervalInBackground: true,
                notifyOnChangeProps: ['data', 'error'],
            })
        });

        const unitsDataFiltered = unitsData?.phase?.units ? unitsData?.phase?.units?.filter( unit => unit?.code.slice(0,-5) === mirs_rsc.slice(0,-5) && unit?.scheduled !== 'Y') : ''

        let queryArray = [];

        //GET all results for training
        Array.isArray(unitsDataFiltered) && unitsDataFiltered?.forEach((unit) => {
            queryArray.push({
                queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase],
                queryFn: getResultsRSC,
                refetchInterval: 5000,
                staleTime: 5000,
                refetchIntervalInBackground: true,
                notifyOnChangeProps: ['data', 'error'],
            })
        });

        //GET cumulative result
        const { data: dataCumulative, isError: isErrorCumulative, isLoading: isLoadingCumulative } = useQuery(
        {
            queryKey: ['cumulativeData', mirs_competition, mirs_language, getLongPhaseRSC(mirs_rsc)],
            queryFn: getCumulativeResult,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            onError: (error) =>
            console.error(`Something went wrong: ${error.message}`),
        });

        //GET data
        const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language, _longEvent],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
        });

    const results = useQueries(queryArray);
    const results1Round = useQueries(queryArray1Round);
    const _isLoading = isLoading || isLoadingCumulative || results.some(result => result.isLoading) || results1Round.some(result => result.isLoading)
    const _isError = isError || isErrorCumulative || results.some(result => result.isError) || results1Round.some(result => result.isError)

    if (_isError) { return <NotAvailable />; }
    if (_isLoading) { return <Loader />; }
    //if (!data?.results) { return <NotAvailable /> }

    const dataFirstRound = results1Round?.find( res => /SJP...................FNL-0001..../.test(res?.data?.results?.eventUnitCode))?.data

    const resultStatus = data?.results?.status?.code;
    const isLive = isLiveStatus(resultStatus) ? true : false

    let training = data?.results?.eventUnitCode.includes('TRNO') || results[0]?.data?.results?.eventUnitCode.includes('TRNO')

    let trial = data?.results?.eventUnitCode.includes('FNL-TR') || data?.results?.eventUnitCode.includes('QUALTR') 

    let qual = data?.results?.eventUnitCode.includes('QUAL0001')

    let firstRound = data?.results?.eventUnitCode.includes('FNL-0001')

    let final = data?.results?.eventUnitCode.includes('FNL-0002')

    const isMixed = getIsMixed(mirs_rsc);

    let trainingRounds = []
        results?.map((res, index) => {
            if (res?.data?.results?.items !== undefined){
                let tabTitle = res?.data?.results?.eventUnitCode.substring(29,30) === '1'
                ? 'HeaderRND_1'
                : res?.data?.results?.eventUnitCode.substring(29,30) === '2'  
                    ? 'HeaderRND_2'
                    : 'HeaderRND_3'
                    trainingRounds.push(
                        <Tab eventKey={`${index}-${mirs_rsc}`} title={<Label data={tabTitle} sport={mirs_discipline}/>}>
                            <SjpTrialResults data={res?.data} config={data?.config}/>
                        </Tab>
                )
            }
        })
        data?.results?.items?.forEach(item => {
            let cumData = dataCumulative?.cumulativeResults?.results?.find( i => i?.participant?.code === item?.participant?.code)
            item.cumData = cumData
        });

    return (
        <>
            {!training
            ? <PageHeader data={data} />
            : <PageHeader data={results[0]?.data} title={results[0]?.data?.results?.eventUnit?.shortDescription.slice(0,-8)}/>
            }
            <div className='mirs-page-container'>
            {isLive && isMixed && !trial
                ? 
                <>
                    <PreviousCompetitorMix data={data} />
                    <CurrentCompetitorMix data={data} />
                </>
            : isLive && !training
                ?
                <>
                    <PreviousCompetitor data={data} />
                    <CurrentCompetitor data={data} />
                </>
                : ''
            }
            {training
                ?
                <>
                    <Tabs id="mirs-navsport" className="mb-3 mirs-tab-result">
                        {trainingRounds}
                    </Tabs>
                </>
                : ''
            }
            {trial || qual
                    ? <SjpTrialResults data={data} />
                    : firstRound || final
                        ? <SjpFinalResults data={data} dataFirstRound={dataFirstRound}/>
                        : ''
            }
            </div>
        </>
    )

}

export default SjpContext;